/* unplugin-vue-components disabled */import script from "./RecordModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordModal.vue?vue&type=script&setup=true&lang=ts"

import "./RecordModal.vue?vue&type=style&index=0&id=f1561108&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1561108"]])

export default __exports__